import { Injectable } from '@angular/core';
import { Quark, HttpGet, Url, HttpResponse, JSONData } from 'sol-request-angular/dist/comunicacao';
import { environment } from 'src/environments/environment';
import { ParametroGrupoService } from './../../services/grl/parametro-grupo.service';
import { GrupoParametro } from '@tivic-team/manager-ts/dist/grl/entities/grupo-parametro.entity';
import { ParametroDTO } from 'app/model/dtos/grl/parametro.dto';
@Injectable()
export class ParametroGrupoController {
    
    constructor() {}

    async getAll(cdGrupoParametro: number): Promise<Array<ParametroDTO>> {
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/parametrogrupo/:cdGrupoParametro',
					environment: environment,
                    pathParams: new JSONData({cdGrupoParametro})
				}),
			}),
			new HttpResponse(
				new Array<ParametroDTO>()
			)
        );
        return await quark.call();
    }
}